import { TermSpeaker } from '@/components/sheets/TermSpeaker';

type TermItemProps = {
  term: string;
  definition?: string;
  extra?: string;
  hasAudio: boolean;
  onPlay: () => void;
};

/** Same mint row as mobile `TermItem`. */
export function TermItem({ term, definition, extra, hasAudio, onPlay }: TermItemProps) {
  return (
    <article className="mb-2.5 flex items-center justify-between rounded-xl bg-[#C4EBC0] px-6 py-4">
      <div className="mr-4 min-w-0 flex-1">
        <p className="font-nunito text-xl font-bold text-[#1E1E1E]">{term}</p>
        {definition ? <p className="font-nunito text-base italic text-[#1E1E1E]">{definition}</p> : null}
        {extra ? <p className="mt-1 font-nunito text-sm text-[#1E1E1E]/70">{extra}</p> : null}
      </div>
      {hasAudio ? <TermSpeaker label={term} onPlay={onPlay} /> : null}
    </article>
  );
}
